import { useState } from 'react';
import { Button } from 'src/components/design-system';

export function ReportExportButton({ onExport, lang, disabled = false }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await onExport();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type="primary" onClick={handleClick} loading={loading} disabled={disabled}>
      {lang.REPORT_EXPORT}
    </Button>
  );
}
